import { roles } from './constants';

const {
  GAMEDAY_VIEW_ONLY,
  GAMEDAY_INVOICE_ONLY,
  GAMEDAY_STANDARD_USER,
  GAMEDAY_EXTERNAL_ADMIN,
  GAMEDAY_INTERNAL_ADMIN,
  GAMEDAY_PRODUCTION_SUPPORT,
  GAMEDAY_SUPER_USER
} = roles;

export const allAdmin = [
  GAMEDAY_EXTERNAL_ADMIN,
  GAMEDAY_INTERNAL_ADMIN,
  GAMEDAY_PRODUCTION_SUPPORT,
  GAMEDAY_SUPER_USER
];

export const internal = [GAMEDAY_SUPER_USER, GAMEDAY_INTERNAL_ADMIN, GAMEDAY_PRODUCTION_SUPPORT];
export const external = [GAMEDAY_VIEW_ONLY, GAMEDAY_INVOICE_ONLY, GAMEDAY_STANDARD_USER, GAMEDAY_EXTERNAL_ADMIN];
export const allAdminAndStandard = [...allAdmin, GAMEDAY_STANDARD_USER];
export const allExceptInvoiceOnly = [...allAdminAndStandard, GAMEDAY_VIEW_ONLY];

const standard = [GAMEDAY_VIEW_ONLY, GAMEDAY_INVOICE_ONLY, GAMEDAY_STANDARD_USER];
const admin = [...standard, GAMEDAY_EXTERNAL_ADMIN];
export const intAdmin = [...admin, GAMEDAY_INTERNAL_ADMIN];

const permissions = {
  GAMEDAY_EXTERNAL_ADMIN: admin,
  GAMEDAY_INTERNAL_ADMIN: intAdmin,
  GAMEDAY_PRODUCTION_SUPPORT: [...standard, ...allAdmin],
  GAMEDAY_SUPER_USER: [...standard, ...allAdmin]
};

export const invoicePermissions = {
  [GAMEDAY_SUPER_USER]: 'OFSI.ROLE_READ_ONLY',
  [GAMEDAY_PRODUCTION_SUPPORT]: 'OFSI.ROLE_READ_ONLY',
  [GAMEDAY_INTERNAL_ADMIN]: 'OFSI.ROLE_READ_ONLY',
  [GAMEDAY_EXTERNAL_ADMIN]: 'OFSI.ROLE_FULL_ACCESS',
  [GAMEDAY_INVOICE_ONLY]: 'OFSI.ROLE_FULL_ACCESS'
};

export const invoicePermissionsAFS = {
  [GAMEDAY_SUPER_USER]: 'INVN.ROLE_READ_ONLY',
  [GAMEDAY_PRODUCTION_SUPPORT]: 'INVN.ROLE_READ_ONLY',
  [GAMEDAY_INTERNAL_ADMIN]: 'INVN.ROLE_READ_ONLY',
  [GAMEDAY_EXTERNAL_ADMIN]: 'INVN.ROLE_FULL_ACCESS',
  [GAMEDAY_INVOICE_ONLY]: 'INVN.ROLE_FULL_ACCESS'
};

export const invoiceAccess = Object.keys(invoicePermissions);

export function canUpdate(admin, user) {
  return permissions[admin].indexOf(user) > -1;
}

export function isAdmin(role) {
  return allAdmin.includes(role);
}

export function isStandardOrAdmin(role) {
  return allAdminAndStandard.includes(role);
}

export function isExternalUser(role) {
  return external.includes(role);
}

export function isExternalAdmin(role) {
  return role === GAMEDAY_EXTERNAL_ADMIN;
}

export function isStandard(role) {
  return role === GAMEDAY_STANDARD_USER;
}

export function isSuperUser(role) {
  return role === GAMEDAY_SUPER_USER;
}

export function isViewOnly(role) {
  return role === GAMEDAY_VIEW_ONLY;
}

export function isProductSupport(role) {
  return role === GAMEDAY_PRODUCTION_SUPPORT;
}

export function canAccessSystemManagement(role) {
  return isSuperUser(role) || isProductSupport(role);
}

export function canAccessInvoices(role) {
  return invoiceAccess.includes(role);
}
